export const sortMultiETA = (etaA, etaB) => {
  const pickupA = etaA.pickupTime;
  const pickupB = etaB.pickupTime;
  const a = pickupA ? new Date(pickupA) : null;
  const b = pickupB ? new Date(pickupB) : null;

  return (
    (a === null) - (b === null) ||
    a - b ||
    (etaB.type === 'leasedShiftProvider') - (etaA.type === 'leasedShiftProvider')
  );
};
